/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const integrationSyncErrorResponseSchema = z.object({
  tooltip: z.string().nullish(),
  translationData: z.object({}).catchall(z.string()).nullish(),
  type: z.enum([
    'PARTIAL_PROCESSING',
    'INVALID_CUSTOM_FIELD_FILTER',
    'INTERNAL_SERVER_ERROR',
    'AUTHENTICATION_FAILED',
  ]),
});
